import React from 'react'
import AgendamentoMensageriaListPageContainer from './AgendamentoMensageriaListPageContainer'

export class AgendamentoMensageriaListPage extends React.Component {
  render() {
    return <AgendamentoMensageriaListPageContainer {...this.props} />
  }
}
